import { Capacitor } from '@capacitor/core';

const isNative = () => Capacitor.isNativePlatform?.() ?? false;

// Hide the Capacitor splash as soon as the Inertia/Vue app has had a chance
// to paint its first frame. The splash plugin's `launchShowDuration` is the
// safety net for the case where the WebView never finishes loading; this
// hook is the normal exit path.
async function hideSplash() {
    // Two rAFs: the first lets the current mount tick complete, the second
    // confirms the next paint has actually happened.
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: 300 });
}

// Wire up the native-only side effects the WebView needs from JS. Web is a
// no-op via the `isNative()` guard, so the dynamic imports below never fire
// in a browser. Add new Capacitor bridges here (back button, deep links,
// push, etc.) rather than in `app.js`.
export function setupNativeHooks() {
    if (!isNative()) {
        return;
    }

    // Fire-and-forget, but surface failures to the console so a broken
    // splash hide doesn't disappear silently — the auto-hide timeout in
    // `capacitor.config.ts` is the actual safety net regardless.
    hideSplash().catch((error) => {
        console.warn('[curie] failed to hide native splash:', error);
    });
}
